import type { RouteObject } from 'react-router-dom';

/**
 * Videos area. OWNED BY `m6m7-workouts` (M6); see docs/BUILD-ORCHESTRATION.md.
 *
 * Add screens as children below. router.tsx already includes these routes, so a new
 * screen inside this area never needs a change outside this folder. Pages load lazily.
 */
export const videosRoutes: RouteObject[] = [
  {
    path: 'videos',
    handle: { crumb: 'Videos' },
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./VideosPage')).VideosPage }) },
    ],
  },
];
